var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKeyIcon = function SvgKeyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "31C757CE-1958-46F7-A3D8-19E5EF8A7135@1.50x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Episode-Card-Locked",
    transform: "translate(-283.000000, -183.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(271.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4,12 C25.08,12 28.8,15.72 28.8,20.4 C28.8,21.4763862 28.603217,22.5019896 28.2432308,23.4432308 L35.64,30.84 C35.88,31.08 36,31.32 36,31.68 L36,34.8 C36,35.52 35.52,36 34.8,36 L31.68,36 C31.32,36 31.08,35.88 30.84,35.64 L30,34.8 L30,32.4 L27.6,32.4 L27.6,30 L25.2,30 L23.4432308,28.2432308 C22.5019896,28.603217 21.4763862,28.8 20.4,28.8 C15.72,28.8 12,25.08 12,20.4 C12,15.72 15.72,12 20.4,12 Z M18.6,15.6 C16.92,15.6 15.6,16.92 15.6,18.6 C15.6,20.28 16.92,21.6 18.6,21.6 C20.28,21.6 21.6,20.28 21.6,18.6 C21.6,16.92 20.28,15.6 18.6,15.6 Z",
    id: "Shape"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKeyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key_icon.1f4137b0.svg";
export { ForwardRef as ReactComponent };